<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">申请人：</span>
        </div>
        <el-select v-model="formData.applicantCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item.personCode"
                     :label="item.personName" :value="item.personCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">调班日期：</span>
        </div>
        <el-date-picker v-model="formData.workDate" type="date" format='yyyy-MM-dd' value-format="yyyy-MM-dd" size="small" style="width: 280px" placeholder="调班日期"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">原班次：</span>
        </div>
        <el-input v-model="formData.sourceClassesName" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">调班班次：</span>
        </div>
        <el-select v-model="formData.modifyClassesCode" size="small" style="width: 280px">
          <el-option v-for="item in attendanceClassList" :key="item.classesCode"
                     :label="item.classesName" :value="item.classesCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">调班原因：</span>
        </div>
        <el-input v-model="formData.reason" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {getObjectURL} from '../../../utils/toBase64'
import {bus} from '../../../utils/bus'
import {api} from '../../api/AttendancePoint'
import {nError, nSuccess} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'attendance-switch-modify',
  data () {
    return {
      breadcrumb: [{
        value: '智慧考勤',
        name: 'attendance-department-manage'
      }, {
        value: '调班管理'
      }],
      mainTitle: '修改调班',
      subheading: '',

      responsiblePersonList: [],
      attendanceClassList: [],
      formData: {
        applicantCode: '',
        workDate: '',
        sourceClassesCode: '',
        sourceClassesName: '',
        modifyClassesCode: '',
        modifyClassesName: '',
        reason: ''
      },
    }
  },
  created () {
    this.getAttendanceReplaceByCode()
    this.remoteMethod()
  },
  methods: {
    // 查询
    getAttendanceReplaceByCode () {
      this.$axios.get(`${api.getAttendanceReplaceByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.formData = data
          }
        })
        .catch(errorHandler('查询失败'))
    },

    remoteMethod (query) {
      this.getPersonList(query)
    },

    // 获取人员列表
    getPersonList (searchKey) {
      this.$axios.post(api.getAttendanceGroupUserList, {
        searchKey: searchKey || ''
      })
        .then(res => {
          let list = res.data.data
          this.responsiblePersonList = list
        })
        .catch(errorHandler('获取人员列表失败'))
    },

    // 获取人员原班次
    getUserAttendanceSchedule () {
      this.$axios.post(api.getUserAttendanceSchedule, {
        personCode: this.formData.applicantCode,
        workDate: this.formData.workDate
      })
        .then(res => {
          let data = res.data.data
          this.formData.sourceClassesCode = data.classesCode || ''
          this.formData.sourceClassesName = data.classesName || ''
        })
        .catch(errorHandler('获取人员列表失败'))
    },

    // 获取班次列表
    getAttendancePersonClassesList () {
      this.$axios.post(api.getAttendancePersonClassesList, {
        personCode: this.formData.applicantCode
      })
        .then(res => {
          let list = res.data.data
          this.attendanceClassList = list
        })
        .catch(errorHandler('获取人员列表失败'))
    },

    toManagementPage () {
      this.$router.push({
        name: 'attendance-switch-manage'
      })
    },

    // 修改
    confirm () {
      if (!this.formData.applicantCode) {
        nError('请选择申请人')
        return false
      }
      if (!this.formData.workDate) {
        nError('请选择调班日期')
        return false
      }
      if (!this.formData.modifyClassesCode) {
        nError('请选择调班班次')
        return false
      }
      this.attendanceClassList.map(v => {
        if (v.classesCode === this.formData.modifyClassesCode) {
          this.formData.modifyClassesName = v.classesName
        }
      })
      this.$axios.post(api.updateAttendanceReplace, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.toManagementPage()
          }
        })
        .catch(errorHandler('修改失败'))
    },

    cancel () {
      this.toManagementPage()
    }
  },

  watch: {
    'formData.applicantCode': {
      handler(newName, oldName) {
        this.getAttendancePersonClassesList()
        if (this.formData.workDate) {
          this.getUserAttendanceSchedule()
        }
      },
      deep: true
    },
    'formData.workDate': {
      handler(newName, oldName) {
        if (this.formData.applicantCode) {
          this.getUserAttendanceSchedule()
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line>div {
  margin-right: 20px;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 190px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #D7D7D7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: .7;
}
</style>

<style lang="less">
.el-switch {
  height: 30px;
}
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceSwitch/AttendanceSwitchModify.vue